<template>
    <b-card :style="{'max-width': '1500px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}" class="text-monospace"> 
        <Backer />
        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm" style="margin-top: 10px;">
            <b-card-text>
                <h4>Purchase Order </h4>
            </b-card-text>
            <b-card header="Info" style="margin-top: 10px; font-size: 13px;">
                <div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">ORDER TYPE</b-card-text>
                        <div class="field-inline-field">
                            <b-form-select
                                v-model="data.order_type"
                                :options="purchase_order_types"
                                size="sm"
                            >
                            </b-form-select>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">
                            PI # <span v-if="!data.po_number"><b-badge size="sm" variant="secondary" @click="data.po_number=Math.round(Date.now() / 1000);">create</b-badge></span>
                        </b-card-text>
                        <div class="field-inline-field">
                            <b-input size="sm" v-model="data.po_number" autocomplete="off" ></b-input>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">INVOICE #</b-card-text>
                        <div class="field-inline-field"><b-input size="sm" v-model="data.invoice_number" autocomplete="off" ></b-input></div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">CONTAINER #</b-card-text>
                        <div class="field-inline-field"><b-input size="sm" v-model="data.container_number" autocomplete="off" ></b-input></div>
                    </div>

                    <div class="field-set-inline" style="width: 130px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">VENDOR</b-card-text>
                        <div class="field-inline-field">
                            <b-form-select
                                v-model="data.vendor_id"
                                :options="packet.vendors"
                                size="sm"
                            >
                            </b-form-select>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 200px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">FOB PRICES</b-card-text>
                        <div class="field-inline-field"><b-input size="sm" v-model="data.fob_prices" autocomplete="off"  style="font-size: 11px; width: 200px;"></b-input></div>
                    </div>

                    <div class="field-set-inline" style="width: 50px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">TARIFF</b-card-text>
                        <div class="field-inline-field"><b-input size="sm" v-model="data.tariff" autocomplete="off"  style="font-size: 11px; width: 50px;"></b-input></div>
                    </div>

                    <div class="field-set-inline" style="width: 100px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">INVOICE AMT</b-card-text>
                        <div class="field-inline-field"><b-input size="sm" v-model="data.invoice_amount" autocomplete="off"  style="font-size: 11px; width: 100px;"></b-input></div>
                    </div>
                </div>

                <div style="margin-top: 10px;">
                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">REQ SHIP DATE</b-card-text>
                        <div class="field-inline-field">
                            <!-- <flat-pickr v-model="data.requested_ship_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 2px; font-size: 12px; text-align: center; border: 1px solid gray;"></flat-pickr> -->

                            <date-picker v-model="data.requested_ship_date" format="MM-DD-YYYY" valueType="format"
                             style="width: 130px; font-size: 9px;"
                            ></date-picker>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">PROD START DATE</b-card-text>
                        <div class="field-inline-field">
                            <!-- <flat-pickr v-model="data.production_start_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 2px; font-size: 12px; text-align: center; border: 1px solid gray;"></flat-pickr> -->

                            <date-picker v-model="data.production_start_date" format="MM-DD-YYYY" valueType="format"
                             style="width: 130px; font-size: 9px;"
                            ></date-picker>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">ETD</b-card-text>
                        <div class="field-inline-field">
                            <!-- <flat-pickr v-model="data.etd" :config="{ dateFormat: 'm-d-Y' }" style="padding: 2px; font-size: 12px; text-align: center; border: 1px solid gray;"></flat-pickr> -->
                            <date-picker v-model="data.etd" format="MM-DD-YYYY" valueType="format"
                             style="width: 130px; font-size: 9px;"
                            ></date-picker>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">RELEASE DATE</b-card-text>
                        <div class="field-inline-field">
                            <!-- <flat-pickr v-model="data.release_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 2px; font-size: 12px; text-align: center; border: 1px solid gray;"></flat-pickr> -->
                            <date-picker v-model="data.release_date" format="MM-DD-YYYY" valueType="format"
                             style="width: 130px; font-size: 9px;"
                            ></date-picker>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">ETA</b-card-text>
                        <div class="field-inline-field">
                            <!-- <flat-pickr v-model="data.eta" :config="{ dateFormat: 'm-d-Y' }" style="padding: 2px; font-size: 12px; text-align: center; border: 1px solid gray;"></flat-pickr> -->
                            <date-picker v-model="data.eta" format="MM-DD-YYYY" valueType="format"
                             style="width: 130px; font-size: 9px;"
                            ></date-picker>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">DUE DATE</b-card-text>
                        <div class="field-inline-field">
                            <!-- <flat-pickr v-model="data.due_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 2px; font-size: 12px; text-align: center; border: 1px solid gray;"></flat-pickr> -->
                            <date-picker v-model="data.due_date" format="MM-DD-YYYY" valueType="format"
                             style="width: 130px; font-size: 9px;"
                            ></date-picker>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">INVOICE PAID DATE</b-card-text>
                        <div class="field-inline-field">
                            <!-- <flat-pickr v-model="data.invoice_paid_date" :config="{ dateFormat: 'm-d-Y' }" style="padding: 2px; font-size: 12px; text-align: center; border: 1px solid gray;"></flat-pickr> -->
                            <date-picker v-model="data.invoice_paid_date" format="MM-DD-YYYY" valueType="format"
                             style="width: 130px; font-size: 9px;"
                            ></date-picker>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 10px;">
                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px; border: 1px dashed;" v-if="data.created_on">
                        <b-card-text class="field-inline-label">Created On:</b-card-text>
                        <div class="field-inline-field">
                            {{ parse_dt(data.created_on || getNow()) }}
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 200px; padding: 0px; margin: 0px; border: 1px dashed;" v-if="data.created_by">
                        <b-card-text class="field-inline-label" style="display: block;">Created By:</b-card-text>
                        <div class="field-inline-field">
                            {{ data.created_by || packet.userDetails.username }}
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 150px; padding: 0px; margin: 0px; border: 1px dashed;" v-if="data.last_saved_by">
                        <b-card-text class="field-inline-label">Last Saved:</b-card-text>
                        <div class="field-inline-field">
                            <div>{{ parse_dt(data.last_saved_on) }}</div>
                        </div>
                    </div>

                    <div class="field-set-inline" style="width: 200px; padding: 0px; margin: 0px;">
                        <b-card-text class="field-inline-label">Production Status</b-card-text>
                        <div class="field-inline-field">
                            <b-form-select
                                v-model="data.production_status"
                                :options="production_statuses"
                                size="sm"
                            >
                            </b-form-select>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 10px; padding: 5px; background: #efefef;">
                    <div>
                        <input type="file" @change="previewImage"  accept="image/*"></input>
                    </div>

                    <div style="border: 1px dashed; padding: 1px; margin-top: 5px;" v-if="data.images.length > 0">
                        <div v-for="image, imgidx in data.images" v-bind:key="imgidx" style="display: inline-block; width: 150px;">
                            <div v-if="image" >
                                <span v-if="image.raw">
                                    <img class="preview" :src="image.raw"  @mouseover="hovered_image = image" 
                                    @mouseleave="hovered_image = {}" width="150">
                                </span>
                                <span v-else>
                                    <img class="preview" :src="image.url"  @mouseover="hovered_image = image" 
                                    @mouseleave="hovered_image = {}" width="150">
                                </span>
                            </div>
                        </div>
                    </div>

                    <b-card style="margin-top: 10px; text-align: center;" v-if="Object.keys(hovered_image).length > 0">
                        <div style="font-size: 11px;">Image preview</div>
                        <span v-if="hovered_image.raw">
                            <img :src="hovered_image.raw" width="300" />
                        </span>
                        <span v-else>
                            <img :src="hovered_image.url" width="300" />
                        </span>
                    </b-card>
                </div>
            </b-card>

            <div style="margin-top: 10px; font-size: 13px;">
                <b-card header="Items">
                    <div style="margin: 10px;">
                        
                        <div class="field-inline-field" style="width: 600px;">
                            
                            <vue-autosuggest
                                ref="autosuggest"
                                v-model="query"
                                @selected="selectHandler"
                                :suggestions="filteredSuggestions"
                                :getSuggestionValue="s => s.item.product_sku +' (' +s.item.product_name + ')' "
                                :inputProps="inputProps"
                                style="width: 600px; position: relative; font-size: 14px;"

                            >
                                <template slot-scope="{ suggestion }">
                                    <div>
                                        <b>{{suggestion.item.product_sku}} ({{ suggestion.item.product_name }})</b>
                                        <!-- <p>- {{suggestion.item.topping.map(topping => topping.type).join(", ")}}</p> -->
                                    </div>
                                </template>
                            </vue-autosuggest>


                        </div>
                        <div class="field-inline-field">
                            <b-button size="sm" variant="success" @click="addItem">Add</b-button>
                            <b-button size="sm" variant="dark" @click="addCustom">Add Custom</b-button>
                        </div>
                    </div>

                    <div style="margin: 10px; " v-if="data.items.length > 0">
                        <table style="width: 100%;">

                            <thead>
                                <tr style="background: #efefef;">
                                    <!-- <td class="ipt_tdhr">ID</td> -->
                                    <td class="ipt_tdhr">SKU</td>
                                    <!-- <td class="ipt_tdhr">Name</td> -->
                                    <td class="ipt_tdhr" style="width: 120px;">Color</td>
                                    <td class="ipt_tdhr" style="width: 150px;">Category</td>
                                    <td class="ipt_tdhr" style="width: 80px;">Lnded Cost</td>
                                    <td class="ipt_tdhr" style="width: 80px;">Whlsl Price</td>
                                    <td class="ipt_tdhr" style="width: 80px;">Selling Price</td>
                                    <td class="ipt_tdhr" style="width: 80px;">FOB Price</td>
                                    <td class="ipt_tdhr" style="width: 70px;">Cubes</td>
                                    <td class="ipt_tdhr" style="width: 180px;">Receive At</td>
                                    <td class="ipt_tdhr" style="width: 60px;">Ordrd</td>
                                    <td class="ipt_tdhr" style="width: 60px;">Rcvd</td>
                                    <td class="ipt_tdhr" style="width: 60px;">Dmgd</td>
                                    <!-- <td class="ipt_tdhr">Diff</td> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item,idx in data.items">
                                    <!-- <td class="ipt_tdr">
                                        {{ item.product_id }}
                                    </td> -->
                                    <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <b-input v-model = "item.product_sku" style="width: auto; font-size: 12px;" placeholder="enter product sku"></b-input>
                                        </span>
                                        <span v-else>
                                            {{ item.product_sku }}
                                        </span>
                                    </td>
                                    <!-- <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.product_name" style="width: auto;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.product_name }}
                                        </span>
                                    </td> -->
                                    <td class="ipt_tdhr font10">
                                        <b-input v-model = "item.color" style=" font-size: 12px;" placeholder="color"></b-input>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <div style="margin: 3px;">
                                                <b-form-select
                                                    v-model="item.category_id"
                                                    :options="packet.categories"
                                                    size="sm"
                                                >
                                                </b-form-select>
                                            </div>
                                        </span>
                                        <span v-else>
                                            {{ packet.categoriesdict[item.category_id] }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.landed_cost" style="width: 55px;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.landed_cost }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.wholesale_price" style="width: 55px;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.wholesale_price }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.selling_price" style="width: 55px;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.selling_price }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.fob_price" style="width: 55px;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.fob_price }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <span v-if="item.is_custom">
                                            <input v-model = "item.cubes" style="width: 55px;"/>
                                        </span>
                                        <span v-else>
                                            {{ item.cubes }}
                                        </span>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <div style="margin: 3px;">
                                            <b-form-select
                                                v-model="item.locsub"
                                                :options="packet.locsubs"
                                                size="sm"
                                                style="font-size: 10px;"
                                            >
                                            </b-form-select>
                                        </div>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <input v-model="item.ordered_quantity" style="width: 30px; text-align: center"/>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <input v-model="item.received_quantity" style="width: 30px; text-align: center"/>
                                    </td>
                                    <td class="ipt_tdhr font10">
                                        <input v-model="item.damaged_quantity" style="width: 30px; text-align: center;"/>
                                    </td>

                                    <!-- <td class="ipt_tdhr font10" style="width: 30px;">
                                        <span v-if="item.ordered_quantity != item.received_quantity & item.ordered_quantity != null & item.received_quantity != null" style="background: #FFD54F; padding: 4px;">
                                            {{ (item.ordered_quantity - item.received_quantity || 0) }}
                                        </span>
                                        <span v-else>
                                            {{ (item.ordered_quantity - item.received_quantity || 0) }}
                                        </span>
                                    </td> -->
                                    <!-- <td class="ipt_tdhr font10">
                                        <b-badge style="cursor: pointer; font-size: 12px; margin: 3px;" variant="dark">Images</b-badge>
                                        <b-badge style="cursor: pointer; font-size: 12px; margin: 3px;" variant="danger" @click="removeItemFromPO(idx)">Remove</b-badge>
                                    </td> -->

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style="margin: 10px;" v-if="data.items.length > 0">
                        <b-button 
                            size="md" 
                            variant="primary" 
                            @click="promptSavePurchaseOrder"
                        >Save</b-button>
                    </div>
                </b-card>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    import { VueAutosuggest } from "vue-autosuggest";

    import moment from 'moment'

    // import flatPickr from 'vue-flatpickr-component';
    // import 'flatpickr/dist/flatpickr.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';


    export default {
        name: "PurchaseOrder",
        props: ["viewdata"],
        components: {Backer,Multiselect,VueGoodTable,VueAutosuggest,DatePicker},
        data: function(){
            return {
                packet: {},
                userDetails: {properties: {}},
                data: {
                    items: [],
                    container_number: null,
                    po_number: null,
                    po_name: null,
                    vendor_id: null,
                    production_status: null,
                    eta: null,
                    created_on: null,
                    created_by: null,
                    last_saved_by: null,
                    images: []
                },
                hovered_image: {},
                items_being_loaded: false,
                vendors: [],
                vendorsdict: {},
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                categories: [],
                categoriesdict: {},
                purchase_order_types: [
                    {value: "international", text: "International"},
                    {value: "domestic", text: "Domestic"},
                ],
                production_statuses: [
                    // {value: 1, text: "Order Pending"},
                    // {value: 2, text: "Order Approved"},
                    {value: 1, text: "Open Orders"},
                    {value: 2, text: "In Production"},
                    {value: 3, text: "Ready to Ship"},
                    {value: 4, text: "In Transit"},
                    {value: 5, text: "Received"}
                ],
                production_statuses_dict: {
                    1: "Open Orders",
                    2: "In Production",
                    3: "Ready to Ship",
                    4: "In Transit",
                    5: "Received"
                },
                product_suggestions: [],
                selected: null,
                inputProps: {
                    id: "autosuggest__input",
                    placeholder: "Search SKUs to add"
                },
                query: "",
                po_number: null, //this.$route.params.po_number
            }
        },
        computed: {
            filteredSuggestions() {
                if (!this.query){
                    return []
                }
                return [
                    {
                        data: this.product_suggestions.filter(item => {
                            return (
                                ( 
                                item.product_name.toLowerCase().indexOf(this.query.toLowerCase()) > -1
                                ||
                                item.product_sku.toLowerCase().indexOf(this.query.toLowerCase()) > -1
                                )
                            );
                        })
                    }
                ];
            }
        },
        methods: {
            parse_dt: function(dt){
                return moment(dt).format("MM-DD-YYYY")
            },
            previewImage: function(event) {
                // Reference to the DOM input element
                var input = event.target;


                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    let img = {raw: "", url: "", file: null}
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e ) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        img.raw = e.target.result
                        this.data.images.push(img);
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    img = {raw: "", url: "", file: input.files[0]}  
                    reader.readAsDataURL(input.files[0]);
                    console.log(this.data.images)
                }
            },
            formatDt: function(dtstr){
                return moment(dtstr).format('MM/DD/YYYY')
            },
            getNow: function(){
                return moment().format("MM/DD/YYYY")
            },
            selectHandler: function(item) {
                if (item) {
                    this.selected = item.item;
                }
            },
            addItem: function(e) {
                if (e){
                    e.preventDefault();
                }
                let item = this.selected;

                item.ordered_quantity = null;
                item.received_quantity = null;
                item.damaged_quantity = null;
                item.color = null;
                item.is_custom = false;

                this.data.items.push(item);
                this.selected = null;
                this.query = "";
                document.getElementById("autosuggest__input").value = null;
            },
            addCustom: function(e) {
                if (e){
                    e.preventDefault();
                }
                let item = {
                    product_id: -1,
                    product_sku: null,
                    product_name: null,
                    category_id: null,
                    landed_cost: null,
                    wholesale_price: null,
                    selling_price: null,
                    fob_price: null,
                    cubes: null,
                    location_id: null,
                    sublocation_id: null,
                    ordered_quantity: null,
                    received_quantity: null,
                    damaged_quantity: null,
                    color: null,
                };

                item.is_custom = true;
                this.data.items.push(item);
                this.selected = null;
                this.query = "";
                document.getElementById("autosuggest__input").value = null;
            },
            fetch_prereqs: function() {
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/product/get_products_list_v2/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getAsyncP,
                        s: function(response){
                            if (response.data.result){
                                that.product_suggestions = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading products list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else{
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function(e){
                if (e){
                    e.preventDefault();
                }

                let po_number = this.po_number;
                if (po_number){
                    let path = "/api/inventory/get_purchase_order/"
                    let data = {po_number: po_number}
                    let that = this;
                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"danger"}
                            );
                        }
                        else {
                            that.data = response.data.result;
                        }
                        that.items_being_loaded = false;
                    }
                    let f = function(error){
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading purchase order.", 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }
                    this.items_being_loaded = true;
                    Requestor.getAsyncP(path, data, this, s, f);
                }
            },
            validate: function(data){
                let errors = [];
                let sku_keys = this.product_suggestions.reduce((map, obj) => (map[(obj.product_sku || " N/A ") .toLowerCase()] = true, map), {});
                let name_keys = this.product_suggestions.reduce((map, obj) => (map[(obj.product_name || " N/A ").toLowerCase()] = true, map), {});
                // if (!data.po_name){
                //     errors.push("PO should have a name.")
                // }
                if (!data.vendor_id){
                    errors.push("PO should havbe a specific vendor assigned.")
                }
                if (!data.po_number){
                    errors.push("Please specify a valid PO number.")
                }
                // if (!data.eta || !( moment(moment(data.eta).format("MM/DD/YYYY"), "MM/DD/YYYY", true).isValid() ) ) {
                //     errors.push("Please specify a valid ETA date.")
                // }
                if (!data.production_status){
                    errors.push("Please specify a valid production status")
                }
                let validator_keys = ["product_id", "product_sku","ordered_quantity"];

                let items = data.items.filter(function(d){
                    return (d.product_sku || "N/A") != "N/A"
                })

                if (items.length  <= 0){
                    errors.push("Please specify valid items");
                    return errors
                }
                else {
                    for (var i=0; i<data.items.length; i++){
                        let item = data.items[i];
                        for (var j=0; j<validator_keys.length; j++){
                            if (!item[validator_keys[j]]){
                                errors.push("All items should have valid "+validator_keys[j]+" specified");
                                break
                            }
                        }
                    }
                }
                return errors;
            },
            promptSavePurchaseOrder: function(e){
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let data = this.data;
                this.savePurchaseOrder();
            },
            savePurchaseOrder: function(e){
                if (e){
                    e.preventDefault();
                }

                let data = this.data;
                let errors = this.validate(data);
                if (errors.length > 0){
                    this.$vex.dialog.alert({message: errors[0]});
                    return
                }
                
                if (!data.created_by){
                    data.created_by = this.packet.userDetails.username;
                    data.created_on = this.getNow();
                }
                data.last_saved_on = this.getNow();
                data.last_saved_by = this.packet.userDetails.username;
                //data.eta = moment(data.eta, "YYYY-MM-DD").format("MM/DD/YYYY")
                

                let path = "/api/inventory/save_purchase_order/";
                let that = this;

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully saved purchase order.", 
                            {title: "Error", autoHideDelay: 1500, variant:"success"}
                        );

                        if (that.$route.params.po_number){
                            location.reload();
                        }
                        else {
                           let po_number = response.data.result.po_number;
                            if (po_number) {
                                that.$router.push("/purchase_orders/");
                            } 
                        }
                    }
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred while trying to save. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }

                Requestor.postSyncP(path, data, this, s, f);
            },
            removeItemFromPO: function(idx){

            },
            fillOrder: function(viewdata){
                if (viewdata.items){
                    for (var i=0; i<viewdata.items.length; i++){
                        let product_id = viewdata.items[i].product_id;
                        let product_sku = viewdata.items[i].product_sku;
                        let quantity = viewdata.items[i].quantity;

                        let exists = this.product_suggestions.filter(function(d){
                            return (d.product_id == product_id) && (d.product_sku == product_sku)
                        });
                        if (exists.length > 0){
                            this.selected = exists[0];
                            this.addItem();
                            this.selected = null;
                            this.data.items[this.data.items.length - 1].ordered_quantity = quantity;
                        }
                        else {
                            this.addCustom();
                            this.data.items[this.data.items.length - 1].product_id = product_id;
                            this.data.items[this.data.items.length - 1].product_sku = product_sku;
                            this.data.items[this.data.items.length - 1].ordered_quantity = quantity;
                        }
                    }
                }
                this.data.po_number = viewdata.identifier;
                this.data.vendor_id = viewdata.vendor_id;
                this.data.production_status = 1
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails); 
            this.fetch_prereqs();
            if (this.viewdata){
                let viewdata = JSON.parse(JSON.stringify(this.viewdata));
                this.po_number = viewdata.po_number;
            }
            else {
                this.po_number = this.$route.params.po_number
                this.fetch_init();
            }
            
            
        }
        

    }
</script>

<style scoped>
    .field-inline-label {
        display: inline-block;
        margin-right: 10px;
    }

    .field-inline-field {
        display: inline-block;
        margin-right: 10px;
        margin-top: 2px;
    }

    .field-set-inline {
        display: inline-block;
        margin: 10px;
        vertical-align: block;
    }

    p {
        margin: 0px;
    }

    .font10 {
        font-size: 13px;
        padding: 0px;
    }

    img.preview {
        width: 150px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
        margin: 5px;
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrders/PurchaseOrder.vue